import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

const COMPACT_LAYOUT_QUERY = '(max-width: 959px)';

@Component({
  standalone: false,
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {
  private readonly destroyRef = inject(DestroyRef);

  compact = false;
  drawerOpened = true;

  constructor(
    breakpoints: BreakpointObserver,
    private router: Router,
  ) {
    breakpoints.observe(COMPACT_LAYOUT_QUERY).pipe(
      map(result => result.matches),
      distinctUntilChanged(),
      takeUntilDestroyed(),
    ).subscribe(compact => {
      this.compact = compact;
      this.drawerOpened = !compact;
    });

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(() => this.closeOverlay());
  }

  toggleMenu(): void {
    this.drawerOpened = !this.drawerOpened;
  }

  closeOverlay(): void {
    if (this.compact) {
      this.drawerOpened = false;
    }
  }

  onDrawerOpenedChange(opened: boolean): void {
    this.drawerOpened = this.compact ? opened : true;
  }
}
